<header class="mainWrap"  [ngClass]="{'page-scroll-header': isScrolled}">
<section class="mainWraps">
    <div class="mainWrapHeader">
        <div class="logoWrap" [routerLink]="['/']">
            <img class="onDesktopLogo" src="../../../assets/images/patch/logo/logo1.png">
            <img class="onMobileLogo" src="../../../assets/images/patch/logo/logo2.png">
        </div>
        <div class="navBarWrap">
            <div class="contactUsWrap">
                <button (click)="onUpdateActive('contact')"  [routerLink]="['/contact']">
                    CONTACT US
                </button>
            </div>
            <div class="navList">
                <ul>
                    <li>
                        <span [ngClass]="'home' === activeElement ? 'active' : 'none'" (click)="onUpdateActive('home')" [routerLink]="['/']">HOME</span>
                    </li>
                    <li>
                        <span [ngClass]="'about' === activeElement ? 'active' : 'none'" (click)="onUpdateActive('about')" [routerLink]="['/about']">ABOUT US</span>
                    </li>
                    <li>
                        <span [ngClass]="'services' === activeElement ? 'active' : 'none'" (click)="onUpdateActive('services')" [routerLink]="['/services']">
                            SERVICES
                        </span>
                    </li>
                    <li>
                        <span [ngClass]="'industries' === activeElement ? 'active' : 'none'" (click)="onUpdateActive('industries')" [routerLink]="['/industries']">
                            INDUSTRIES
                        </span>
                    </li>
                    <li>
                        <span [ngClass]="'technology' === activeElement ? 'active' : 'none'" (click)="onUpdateActive('technology')" [routerLink]="['/technology']">
                            TECHNOLOGIES
                        </span>
                    </li>
                    <li>
                        <span [ngClass]="'client' === activeElement ? 'active' : 'none'" (click)="onUpdateActive('client')" [routerLink]="['/client']">
                            CLIENTELE
                        </span>
                    </li>
                </ul>
            </div>
            <div class="menuBarIcon">
                <button id="nav-toggle" (click)="onMenu()" type="button" class="ui-navbar-toggle navbar-toggle" data-toggle="collapse" data-target=".navbar-1">
                    <span class="sr-only">Toggle navigation</span><span class="icon-bar"></span><span class="icon-bar"></span><span class="icon-bar"></span>
                </button>
            </div>
        </div>
    </div>


    <div class="menuWrapForMobile" *ngIf="isMenuBar">
        <div class="menuWrapForMob">
            <ul>
                <li (click)="onUpdateActive('home')" [routerLink]="['/']">
                    <span [ngClass]="'home' === activeElement ? 'active' : 'none'" >HOME</span>
                </li>
                <li (click)="onUpdateActive('about')" [routerLink]="['/about']">
                    <span [ngClass]="'about' === activeElement ? 'active' : 'none'" >ABOUT US</span>
                </li>
                <li  (click)="onUpdateActive('services')" [routerLink]="['/services']">
                    <span [ngClass]="'services' === activeElement ? 'active' : 'none'">
                        SERVICES
                    </span>
                </li>
                <li (click)="onUpdateActive('industries')" [routerLink]="['/industries']">
                    <span [ngClass]="'industries' === activeElement ? 'active' : 'none'" >
                        INDUSTRIES
                    </span>
                </li>
                <li (click)="onUpdateActive('technology')" [routerLink]="['/technology']">
                    <span [ngClass]="'technology' === activeElement ? 'active' : 'none'" >
                        TECHNOLOGIES
                    </span>
                </li>
                <li (click)="onUpdateActive('client')" [routerLink]="['/client']">
                    <span [ngClass]="'client' === activeElement ? 'active' : 'none'" >
                        CLIENTELE
                    </span>
                </li>
                <li (click)="onUpdateActive('contact')" [routerLink]="['/contact']">
                    <span [ngClass]="'contact' === activeElement ? 'active' : 'none'" >
                        CONTACT US
                    </span>
                </li>
            </ul>
        </div>
    </div>
</section>
<div class="forTransparent" *ngIf="isMenuBar" (click)="onMenu()">

</div>
</header>
